import type { DirectFlightDates } from '@optionway/models';

export const useDirectFlightDatesOptions = defineQueryOptions(
  (input: { enabled: boolean; fromCity: string; toCity: string; apiUrl?: string }) => ({
    key: ['direct-flight-dates', input.fromCity, input.toCity],
    query: () => $fetch<DirectFlightDates>(`${input.apiUrl}/search/direct-flights/${input.fromCity}/${input.toCity}`),
    enabled: input.enabled && !!input.apiUrl && !!input.fromCity && !!input.toCity,
    staleTime: 1000 * 60 * 60,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  }),
);
